@if (config(); as cfg) {
	<md-content-box [type]="boxType()" class="lesson-detail-unavailable">
		<div class="unavailable__header">
			<md-icon [icon]="cfg.icon" class="unavailable__icon"></md-icon>
			<span class="unavailable__title">{{ cfg.title }}</span>
		</div>
		<div class="unavailable__body">
			<div class="unavailable__message">{{ cfg.message }}</div>
			@if (activeReason() === 'pending-reschedule' && canReschedule()) {
				<div class="unavailable__actions">
					<button md-button (click)="reschedule()">Reschedule</button>
				</div>
			}
		</div>
	</md-content-box>
}
